/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useState, useEffect, useMemo } from 'react';
import Form from '../../shared/forms/Form';
import useApiInventariosCaja from '../../api/taller/useApiInventariosCaja';
import FieldAutoComplete from '../../shared/controls/fieldAutoComplete';
import Field from '../../shared/forms/Field';
import FormTextBox from '../../shared/forms/FormFields/FormTextBox';
import useForm from '../../shared/forms/useForm';
import ExGrid from '../../shared/Grid/ExGrid';
import ExColumn from '../../shared/Grid/ExColumn';
import AddButton from '../../shared/Grid/Buttons/AddButton';
import constantes from '../../catalogos/constantes';
import FormCheckBox from '../../shared/forms/FormFields/FormCheckBox';
import FieldCheckBox from '../../shared/controls/fieldCheckBox';
import DeleteButton from '../../shared/Grid/Buttons/DeleteButton';
import ButtonIcon from '../../shared/controls/ButtonIcon';
import './controlPatioInventarioCajasDialog.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useLocation } from 'react-router-dom';
import alerts from '../../shared/alerts';
import { useNavigate } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";
import useSeguridad from "../../Seguridad/useSeguridad";

const initialValues = { item: []};

function ControlPatiosInventarioCajas({onClose, onSaved }) {
   const [submitted, setSubmitted] = useState(false);
   const [externo, setExterno]= useState(false);
   const [activeTab, setActiveTab] = useState(0);
  const { state } = useLocation();
  const { patioId: paramId } = useParams();
  const patioId = useMemo(
    () => (paramId ?? state?.patioId ?? null),
    [paramId, state?.patioId]
  );
const seguridad = useSeguridad();
const permisoEnTaller = seguridad.tieneAcceso(constantes.opciones.permisoEnTaller);

  const api = useApiInventariosCaja();
  const history = useNavigate();
  const handleTabChange = (e) => {
    const isExterno = e.index === 1;   
    setActiveTab(e.index);
    setExterno(isExterno);
    cargarConPatio(isExterno);    
  };

  const {
    values: formValues,
    setValues,
    onChange,
    onValidate,
    isValid,
  } = useForm(initialValues);
  const nuevaFila = () => ({
        id:0,
        _uniqueUid: uuid(),
        unidadId: null,
        cargada: false,
        sello: '',
        danada: false,
        taller:false,
        comentariosInventario: '',
        documentoId: null,
        codigo: { sello: '', comentariosInventario: '' },
  });
  const agregarAlInicio = () => {
    setValues(v => ({ ...v, item: [nuevaFila(), ...(v.item ?? [])] }));
  };
  const uuid = () =>
    (typeof crypto !== 'undefined' && crypto?.randomUUID)
      ? crypto.randomUUID()
      : `row_${Math.random().toString(36).slice(2)}`;
  const toAutoValue = (id, nombre) => {
    if (id == null) return null;
    return nombre ? { id, nombre } : id; 
  };
  const toRow = (dto) => {
    const selloPlano =
      dto?.codigo?.sello ?? dto?.sello ?? '';

    const comentariosPlano =
      dto?.codigo?.comentariosInventario ?? dto?.comentariosInventario ?? '';

  const cargadaBool = !!(dto?.cargada ?? dto?.Cargada);
  const danadaBool  = !!(dto?.danada  ?? dto?.Danada);
  const tallerBool  = !!(dto?.taller  ?? dto?.Taller);
  const id = dto?.unidadId ?? dto?.UnidadId ?? dto?.idUnidad ?? dto?.IdUnidad ?? null;
  const nombre =
    dto?.unidadNombre ??
    dto?.NumeroEconomico ??
    dto?.numeroEconomico ??
    dto?.nombre ??
    dto?.descripcion ??
    null;

    return {
      _uniqueUid: dto?._uniqueUid ?? uuid(),
       unidadId: toAutoValue(id, nombre),
      cargada: cargadaBool,
      sello: selloPlano,
      danada: danadaBool,
      taller: tallerBool,
      comentariosInventario: comentariosPlano,
      documentoId: dto?.documentoId ?? null,
      codigo: {
        sello: selloPlano,
        comentariosInventario: comentariosPlano,
      },
      id: dto.id
    };
  };
  async function cargarConPatio(externoArg = externo) {
    if (!patioId) return;
    try {
      const data = await api.obtenerCargarConPatio(patioId, externoArg);
      const rows = Array.isArray(data) ? data.map(toRow) : [];
      setValues(v => ({ ...v, item: rows }));
    } catch (err) {
      console.error('Error cargarConPatio:', err);
    }
  }

  useEffect(() => {
    cargarConPatio();
  }, [patioId]);

  const close = () => {
    setSubmitted(false);
    setValues({ item: [] });
    history(`/taller/controlPatiosInventarioCajas`);
  };

  const onSave = async () => {
    setSubmitted(true);
    if (!isValid) return;

    const patio = Number.parseInt(patioId, 10);
    if (Number.isNaN(patio)) {
      console.error('patioId inválido');
      return;
    }
    const getUnidadId = (u) => {
      if (typeof u === 'string') return 0;
       return u?.id ?? u?.nombre;
    };

    const getCaja = (u) => {
      if (typeof u === 'string') return u;
      return u?.nombre ?? u?.caja ?? u?.value ?? '';
    };

    const items = (formValues.item ?? [])
      .map((a) => ({
        id: a.id,
        unidadId: getUnidadId(a.unidadId),
        caja: getCaja(a.unidadId),       
        enTaller: false,
        patioId: patio,
        sello: a.sello ?? '',
        cargada: a.cargada,
        danada: a.danada,
        taller: a.taller,
        comentariosInventario: a.comentariosInventario ?? '',
      }))

      await api.actualizarInventarioIpad(patioId, { items }, externo);

    onSaved?.();
  };

  const renderFooterModal = () => (
    <div>
      <Button label="Cancelar" onClick={close} className="p-button-outlined" />
      <Button label="Guardar" autoFocus onClick={onSave} />
    </div>
  );

  const quitar = async (id, onDelete) => {
    if ((await alerts.preguntarSiNo('¿Desea eliminar la caja del inventario?')) === true) {    
      onDelete?.();
      
       await api.updateCaja(id,  Number.parseInt(patioId, 10), externo);
    }
  };
  const quitarCajas = async () => {
    if ((await alerts.preguntarSiNo('¿Desea eliminar las caja del inventario?')) === true) {    
    const items = (formValues.item ?? [])
      .map((a) => ({
        unidadId: a.unidadId.id,       
        danada : a.danada,
        taller: a.taller
      }))
      await api.updateCajas( Number.parseInt(patioId, 10), { items },externo);
    }
  };

  return (

            <Dialog
            header="Inventario"
            visible={true}             
            style={{ width: '80%' }}
            onHide={close}
            footer={renderFooterModal}
            blockScroll
            modal
          >
            <TabView  activeIndex={activeTab} onTabChange={handleTabChange}>
            <TabPanel header="CAJAS XIMPLE">
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonIcon title="Eliminar Todo" onClick={() => quitarCajas()} marginTop="6px" iconName="RiDeleteBinLine" />
                  </div>

                  <Form
                    columns={2}
                    values={formValues}
                    onChange={onChange}
                    onValidate={onValidate}
                    submitted={submitted}
                  >
                    <Field
                      field="item"
                      cols={6}
                      render={({ value, onParentChange, ...props }) => (
                        <ExGrid
                         key={`externas-${activeTab}`}  
                          {...props}
                          data={value}
                          onChange={(data) => onParentChange({ item: data })}
                          style={{ width: '100%' }}
                          getEntityId={(row) => row._uniqueUid}
                        >
                          
                          <ExColumn
                            field="unidadId"
                            title="Caja"
                            source="unidades"
                            params={{
                              todasLasEmpresas: true,
                              id: constantes.tiposEquipo.arrastre,
                            }}
                            required
                            cellRenderer={({ row, ...cellProps }) => (
                              <FieldAutoComplete
                                {...cellProps}
                                source="unidades"
                                params={{
                                  todasLasEmpresas: true,
                                  id: constantes.tiposEquipo.arrastre,
                                }}
                                value={row?.unidadId}      
                                  valueKey="id"              
                                  labelKey="nombre"         
                                style={{ width: '100%' }}
                              />
                            )}
                          />
                          <ExColumn
                            field="cargada"
                            title="Cargada/Vacía"
                            required
                            width="25%"
                            cellRenderer={(cellProps) => (
                              <FieldCheckBox
                                {...cellProps}
                                name="cargada"
                                isRadioButton
                                yesOption="Cargada"
                                noOption="Vacía"
                              />
                            )}
                          />

                          <ExColumn
                            field="sello"
                            title="Sello"                
                            width="15%"
                            cellRenderer={({ row, ...cellProps }) => (
                              <FormTextBox
                                {...cellProps}
                                style={{ width: '100%' }}
                              />
                            )}
                          />

                          <ExColumn
                            field="danada"
                            title="Danada"                
                            cellRenderer={(cellProps) => (
                              <FormCheckBox disabled={false} style={{ width: '100%' }} {...cellProps} />
                            )}
                          />

                          <ExColumn
                            field="taller"
                            title="En Taller"                
                            cellRenderer={(cellProps) => (
                              <FormCheckBox
                                style={{ width: '100%' }}
                                 {...cellProps}
                                  disabled={!permisoEnTaller}

                                 />
                            )}
                          />
                          <ExColumn
                            field="comentariosInventario"
                            title="Comentarios"                
                            width="15%"
                            cellRenderer={({ row, ...cellProps }) => (
                              <FormTextBox
                                {...cellProps}              
                                style={{ width: '100%' }}
                              />
                            )}
                          />

                          <ExColumn
                            field="command"
                              headerRenderer={() => (
                              <AddButton onAdd={agregarAlInicio} />
                            )}
                            cellRenderer={({ row, onDelete }) => (
                              <DeleteButton onDelete={() => quitar(row?.unidadId.id, onDelete)} />
                            )}
                            width="50px"
                          />
                        </ExGrid>
                      )}
                    />
                  </Form>
              </TabPanel>
               <TabPanel header="CAJAS EXTERNAS">
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <ButtonIcon title="Eliminar Todo" onClick={() => quitarCajas()} marginTop="6px" iconName="RiDeleteBinLine" />
                </div>
                   <Form
                    columns={2}
                    values={formValues}
                    onChange={onChange}
                    onValidate={onValidate}
                    submitted={submitted}
                  >
                    <Field
                      field="item"
                      cols={6}
                      render={({ value, onParentChange, ...props }) => (
                        <ExGrid
                          {...props}
                          data={value}
                          onChange={(data) => onParentChange({ item: data })}
                          style={{ width: '100%' }}
                          getEntityId={(row) => row._uniqueUid}
                        >
                          
                      <ExColumn
                        field="unidadId"           
                        title="Caja"
                        width="15%"
                        cellRenderer={({ row, onChange, ...cellProps }) => {
                          const valor =
                            typeof row?.unidadId === 'string'
                              ? row.unidadId
                              : row?.unidadId?.nombre ?? '';  

                          return (
                            <FormTextBox
                              {...cellProps}
                              value={valor}                    
                              onChange={(texto) => onChange(texto)}  
                              style={{ width: '100%' }}
                            />
                          );
                        }}
                      />

                          <ExColumn
                            field="cargada"
                            title="Cargada/Vacía"
                            required
                            width="25%"
                            cellRenderer={(cellProps) => (
                              <FieldCheckBox
                                {...cellProps}
                                name="cargada"
                                isRadioButton
                                yesOption="Cargada"
                                noOption="Vacía"
                              />
                            )}
                          />

                          <ExColumn
                            field="sello"
                            title="Sello"                
                            width="15%"
                            cellRenderer={({ row, ...cellProps }) => (
                              <FormTextBox
                                {...cellProps}
                                style={{ width: '100%' }}
                              />
                            )}
                          />

                          <ExColumn
                            field="danada"
                            title="Dañada"                
                            cellRenderer={(cellProps) => (
                              <FormCheckBox disabled={false} style={{ width: '100%' }} {...cellProps} />
                            )}
                          />

                          <ExColumn
                            field="taller"
                            title="En Taller"                
                            cellRenderer={(cellProps) => (
                              <FormCheckBox disabled={false}
                               style={{ width: '100%' }}
                                {...cellProps} />
                            )}
                          />
                          <ExColumn
                            field="comentariosInventario"
                            title="Comentarios"                
                            width="15%"
                            cellRenderer={({ row, ...cellProps }) => (
                              <FormTextBox
                                {...cellProps}              
                                style={{ width: '100%' }}
                              />
                            )}
                          />

                          <ExColumn
                            field="command"
                              headerRenderer={() => (
                              <AddButton onAdd={agregarAlInicio} />
                            )}
                            cellRenderer={({ row, onDelete }) => (
                                <DeleteButton onDelete={() => quitar(row?.unidadId.id, onDelete)} />
                            )}

                            width="50px"
                          />
                        </ExGrid>
                      )}
                    />
                  </Form>     
                
            </TabPanel>
            </TabView>
          </Dialog>
       
  );
}

export default ControlPatiosInventarioCajas;